import template from './help-modal.html';
import controller from './help-modal.controller';

let HelpModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: '$ctrl',
  size: 'lg',
  windowClass: 'hmodal-info animated zoomIn help-modal-window',
  backdrop: true
};

export default HelpModalComponent;



// WEBPACK FOOTER //
// ./client/help/help-modal/help-modal.component.js